<template>
    <div class="deliverable-dates">
        <!-- <div class="deliverable-dates__started">
            <strong class="dates-title">STARTED</strong><br>
            <span class="dates-value">{{ deliverable.created_at | moment("DD MMM, YYYY @ H:mm") }}</span>
        </div>
        <div v-if="deliverable.all_completed" class="deliverable-dates__completed">
            <strong class="dates-title">COMPLETED</strong><br>
            <span class="dates-value">{{ deliverable.completed_at | moment("DD MMM, YYYY @ H:mm") }}</span>
        </div>
        <div v-else class="deliverable-dates__status">
            <strong class="dates-title">LAST MODIFIED</strong><br>
            <span class="dates-value">{{ deliverable.updated_at | moment("DD MMM, YYYY @ H:mm") }}</span>
        </div> -->
        <DeliverableStatusOverview :deliverable="deliverable" />
        <!-- <DeliverableTypeIcon :deliverableTypeId="deliverable.deliverable_template_id" /> -->
    </div>
</template>

<script>
import DeliverableStatusOverview from './DeliverableStatusOverview';
// import DeliverableTypeIcon from './DeliverableTypeIcon';

export default {
    components: {
        DeliverableStatusOverview,
        // DeliverableTypeIcon
    },
    props: ['deliverable'],
    // mounted() {
    //     this.$root.$on('collapseToggleUpdatedRoot', function() {
    //         $('.deliverable-block').each(function(i, obj) {
    //             if($(this).find('.dbox-right-side .collapse-control').hasClass('collapsed')) {
    //                 $(this).find('.deliverable-status-overview').hide();
    //                 $(this).find('.deliverable-dates').css('padding-top', 0);
    //             } else {
    //                 $(this).find('.deliverable-status-overview').show();
    //                 $(this).find('.deliverable-dates').css('padding-top', '15px');
    //             }
    //         });    
    //     });
    // }
};
</script>

<style>
</style>